<template>
  <div class="flex-col">
    <el-upload
      v-if="!disabled && fileList.length < limit"
      class="upload-box"
      :action="action"
      multiple
      :on-change="onChange"
      :show-file-list="false"
      :file-list="fileList"
      :before-upload="beforeAvatarUpload">
      <div class="upload-btn">
        <i class="el-icon-upload"/>选择文件，单个10M以内
      </div>
    </el-upload>
    <div class="file-list-box">
      <div class="file-item" v-for="(item, index) in fileList">
        <div class="item-box">
          <img class="icon" :src="(item.url && matchFileSuffixType(item.name) == 'image') ? item.url : require('@/assets/file_type/list-pic.png')" @click="showFile(item)"/>
          <div class="item-content" @click="showFile(item)">
            <span class="name">{{item.name}}</span>
            <span class="size">{{bytesToSize(item.size)}}</span>
          </div>
          <div class="close-box" @click="deleteFile(item.url, 'url')" v-if="!disabled">
            <i class="el-icon-error" ></i>
          </div>

        </div>
        <el-progress v-if="!item.url" class="bar" :percentage="item.percentage" :format="format" color="#00b899"></el-progress>
      </div>
    </div>

    <image-viewer
      ref="imageViewer"
    />
  </div>
</template>
<script>
  import {toast, isMobile, bytesToSize, matchFileSuffixType} from '@/utils'
  import Constant from '@/constant/index'
  import { ImagePreview } from 'vant';
  import ImageViewer from './imageViewer'
  import emitter from 'element-ui/src/mixins/emitter';

export default {
  components: {
    ImageViewer
  },
  mixins: [emitter],
  props: {
    value: {
      type: Array,
      default: ()=>[]
    },
    disabled: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 99999
    },
  },
  watch: {
    value(fileList) {
      if(fileList.length > 0) {
        this.fileList = [...fileList];
      } else {
        this.fileList = []
      }
    }

  },
  data() {
    return {
      action:Constant.API_HOST + '/remote/talentEntrepreneurship/common/upload',
      fileList:[],
    };
  },
  mounted() {
    if(this.value) {
      this.fileList = this.value
    }
  },

  methods: {
    matchFileSuffixType,
    bytesToSize,
    format(percentage) {
      return '';
    },
    beforeAvatarUpload(file) {
      const isLimit = file.size / 1024 / 1024 < 10;

      if (!isLimit) {
        this.$message.error('上传文件大小不能超过 10MB!');
      }
      let isSuccess = isLimit
      if(!isSuccess) {
        this.deleteFile(file.uid, 'uid')
      }
      return isSuccess;
    },
    onChange(file){
      let status = file.status
      let resp = file.response
      let fileList = this.fileList
      if(status == 'ready') {
        fileList.push(file)
      } else if(status == 'success' && resp.code == 200) {
        let sucessFile = fileList.find(data=> data.uid == file.uid)
        if(sucessFile) {
          sucessFile.id = resp.data.fileId
          sucessFile.url = resp.data.url
        }
        this.fileList = [...fileList]
        this.$emit("input", this.fileList);
        this.$emit("change", this.fileList);
        this.dispatch('ElFormItem', 'el.form.blur', [this.fileList]);
      } else if(status == 'fail' || resp.code != 200){
        this.deleteFile(file.uid, 'uid')
        if(resp && resp.msg) {
          toast(resp.msg)
        }

      }
    },
    deleteFile(value, propName){
      let fileList = this.fileList
      let deleteIndex = -1
      fileList.forEach((data, index)=>{
        if(data[propName] == value) {
          deleteIndex = index
        }
      })
      if(deleteIndex != -1) {
        fileList.splice(deleteIndex, 1);
        this.$emit("input", fileList);
        this.$emit("change", fileList);
        this.dispatch('ElFormItem', 'el.form.blur', [this.fileList]);
      }
    },
    showFile(item){
      if(item.url) {
        if(isMobile()) {
          if(matchFileSuffixType(item.name) == 'image') {
            ImagePreview([item.url])
          } else {
            window.open(item.url)
          }

        } else {
          if(matchFileSuffixType(item.name) == 'image') {
            this.$refs.imageViewer.show([item.url])
          } else {
            window.open(item.url)
          }
        }
      }
    }
  },
};
</script>
<style lang="less" scoped>
  .upload-box{
    width: 100%;
    max-width: 335px;
    margin-top: 5px;
    .upload-btn{
      width: 100%;
      max-width: 335px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      color:#b5b8be;
      border: 1px dashed #d7d9dc;
      cursor: pointer;
      i{
        margin-right: 8px;
      }
      &:hover{
        background: #f0f1f4;
      }
    }
    /deep/.el-upload{
      width: 100% !important;
      line-height: 32px!important;
      user-select: none!important;
      &:focus{
        color: #b5b8be;
      }
    }
  }
  .file-list-box{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .file-item{
      display: flex;
      flex-direction: column;
      max-width: 335px;
      width: 100%;
      height: 100%;
      background: #f5f6f8;
      border: 1px solid #e1e3e5;
      border-radius: 2px;
      position: relative;
      margin-bottom: 10px;
      margin-right: 10px;
      .item-box{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 8px;
        height: 60px;
        .icon{
          width: 40px;
          height:40px;
        }
        .item-content{
          display: flex;
          flex-direction: column;
          flex:1;
          padding: 0 8px;
          line-height: 18px;
          .name{
            width: 230px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 12px;
            color: #000;
          }
          .size{
            font-size: 12px;
            color:#838892;
            margin-top: 5px;
          }
        }
        .close-box{
          cursor: pointer;
          height: 100%;
          display: flex;
          align-items: center;
          .el-icon-error{
            color: #aaa;
            margin: 10px 10px;
          }
        }

      }

      .bar{
        position: absolute;
        bottom: -5px;
        width: 100%;
      }
      /deep/.el-progress-bar{
        padding-right: 0!important;
      }
    }
  }
</style>
